import { FC, useState } from "react";
import { Fixture } from "../../../models/fixture";
import { Team } from "../../../models/team";
import HelperService from '../../../services/helper'
import FixtureService from '../../../services/fixture'
import useNotyf from '../../../context/useNotify';
import { UpdateFixturesDTO } from "../../../models/league";
import { useLeague } from "../../../context/useLeague";
import FixtureCard from "./FixtureCard";
import styled from "styled-components";

interface Props {
    fixture: Fixture
    team: Team
    refresh: () => void
  }

const SubmitScoreForm: FC<Props> = ({ fixture, team, refresh }) => {
    const notyf = useNotyf()
    const { league, getLeagueById } = useLeague();

    // Data
    const [homeScore, setHomeScore] = useState<number | null>(fixture.homeScore);
    const [awayScore, setAwayScore] = useState<number | null>(fixture.awayScore);

    // API
    const updateFixture = async (isDisputed: boolean) => {
        if (homeScore === null || awayScore === null) {
            return
        }
      try {
            const dto: UpdateFixturesDTO = {
              awayScore: awayScore,
              homeScore: homeScore,
              lineupAway: fixture.lineupAway,
              lineupAwayAny: fixture.lineupAwayAny,
              lineupHome: fixture.lineupHome,
              lineupHomeAny: fixture.lineupHomeAny,
              isPlayed: true,
              isDisputed: isDisputed,
            }
            await FixtureService.updateFixture(fixture._id, dto)
            notyf.success("Fixture successfully updated.")
        } catch (err) {
         console.log("Error updating fixture: ", err);
         HelperService.showNotfyErr(notyf, err, "Error updating fixture.");
      } finally {
        handleRefresh()
        refresh()
      }
    }
  
    // Methods
    const handleRefresh = () => {
        if (!league) {
            return
        }
        getLeagueById(league?._id);
      };

    const handleHomeScoreChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const score = e.target.value ? parseInt(e.target.value, 10) : null;
        setHomeScore(score);
    };

    const handleAwayScoreChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const score = e.target.value ? parseInt(e.target.value, 10) : null;
        setAwayScore(score);
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (homeScore === null || awayScore === null) {
            notyf.error("Invalid scores.")
            return;
        }
        updateFixture(fixture.isDisputed);
    };
  
    const handleClickDispute = () => {
      updateFixture(true)
    };
  
  
    return (
        <form onSubmit={handleSubmit} className="h-100 d-flex flex-column justify-content-center p-3">
  <div className="row mb-3" style={{ position: 'relative' }}>
    <FixtureCard fixture={fixture} team={team} />
    <Overlay />
  </div>
  <div className="form-group row mb-2">
    <label className="col-4 col-form-label text-right">Home Score:</label>
    <div className="col-8">
      <input
        type="number"
        className="form-control bg-dark text-white"
        value={homeScore !== null ? homeScore : ''}
        onChange={handleHomeScoreChange}
      />
    </div>
  </div>
  <div className="form-group row mb-2">
    <label className="col-4 col-form-label text-right">Away Score:</label>
    <div className="col-8">
      <input
        type="number"
        className="form-control bg-dark text-white"
        value={awayScore !== null ? awayScore : ''}
        onChange={handleAwayScoreChange}
      />
    </div>
  </div>
  <button type="submit" className="btn btn-primary mt-3" disabled={fixture.isPlayed}>
    Submit
  </button>
  <button
    type="button"
    className={`btn btn-danger mt-3 ${!fixture.isDisputed && fixture.isPlayed ? '' : 'disabled'}`}
    onClick={handleClickDispute}
    disabled={!fixture.isDisputed && fixture.isPlayed ? false : true}
  >
    Dispute Fixture
  </button>
</form>

    );
  };
  
export default SubmitScoreForm
  
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2; // Ensure it's above the card
`;
